import React from 'react';
import PropTypes from 'prop-types';
import { useHostnameTenant } from '../context/HostnameTenantContext';

/**
 * Gate component that renders a loading indicator while the hostname-to-tenant
 * resolution is in progress, then renders children once it completes.
 *
 * The loader is accessible: role="status" and aria-live="polite" announce the
 * loading state to screen readers without interrupting the user.
 */
const HostnameTenantBootstrapGate = ({ children }) => {
  const { status } = useHostnameTenant();

  if (status === 'loading') {
    return (
      <div
        id="hostname-tenant-bootstrap-gate"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <span className="visually-hidden">Anwendung wird geladen…</span>
        <div aria-hidden="true" className="spinner-border text-primary" />
      </div>
    );
  }

  return children;
};

HostnameTenantBootstrapGate.propTypes = {
  children: PropTypes.node.isRequired
};

export default HostnameTenantBootstrapGate;
